module.exports = require("./lib/_stream_writable.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/writable.js
 ** module id = 939
 ** module chunks = 0
 **/